<template>

	<div>
		<collapsible-panel v-if="filteringTools" :external-toggle="panelToggled" v-on:panelRetract="panelToggled = false" panel-size="xl">
			<template slot="panel">

				<h4>Filtering</h4>

				<job-picker
					v-if="showJob && !filterValues.service_id" 
					label="Project" 
					col-class="stacked" 
					job-type="project"
					key="project"
					v-model="filterValues.job_id"
					v-on:change="filterChange">
				</job-picker>

				<job-picker
					v-if="showJob && !filterValues.job_id" 
					label="Service" 
					col-class="stacked" 
					job-type="service"
					key="service"
					v-model="filterValues.service_id"
					v-on:change="filterChange">
				</job-picker>

				<field
					v-if="showUser"
					label="Employee"
					col-class="stacked"
					v-on:change="filterChange"
					v-model="filterValues.user_id"
					:params="{type:'select',options: userOptions()}">
				</field>

				<field v-if="filters && !filters.find(filter => filter[0] == 'supplier_id')"
					label="Supplier"
					col-class="stacked"
					v-on:change="filterChange"
					v-model="filterValues.supplier_id"
					:params="{type:'select',options:supplierOptions}">
				</field>

				<field label="Vendor (contains)"
					col-class="stacked"
					v-on:change="filterChange"
					v-model="filterValues.vendor">
				</field>

				<field label="Vendor Invoice No."
					col-class="stacked"
					v-on:change="filterChange"
					v-model="filterValues.invoice_num">
				</field>

				<field v-if="qboIsActive"
					label="Credit Card"
					col-class="stacked"
					:params="{
						type: 'select',
						options: ccAccountOptions
					}"
					v-on:change="filterChange"
					v-model="filterValues.qbo_account_id">
				</field>
				<field v-else
					label="Card # (last 4)"
					col-class="stacked"
					v-on:change="filterChange"
					:params="{type:'number',min:1000,max:9999,step:1}"
					v-model="filterValues.last_4">
				</field>

				<form-group label="Date Range (from-to)" col-class="stacked">
					<div class="d-flex flex-row">
						<field v-on:change="filterChange" v-model="filterValues.dateFrom" :params="{type:'date',initialDate:initialFromDate}"></field>
						<field v-on:change="filterChange" v-model="filterValues.dateTo" :params="{type:'date',initialDate:'today'}"></field>
					</div>
				</form-group>

				<field label="Expense Group"
					col-class="stacked"
					v-on:change="fetchExpenseCodes([],[['group_id',$event]])"
					:params="{type:'select',options:expenseGroupOptions}"
					v-model="group_id">
				</field>

				<field v-if="group_id > 0"
					label="Expense Code"
					col-class="stacked"
					:params="{type:'select',options:expenseCodesFilteredOptions}"
					v-on:change="filterChange"
					v-model="filterValues.code_id">
				</field>

				<field label="Reviewed"
					col-class="stacked"
					v-on:change="filterChange"
					:params="{type:'btn-group',buttons:[
						{text: 'All',value: 'all'},
						{text: 'Reviewed',value: 'reviewed'},
						{text: 'Un-reviewed',value: 'unreviewed'},
					]}"
					v-model="filterValues.reviewed">
				</field>

				<field label="Processed"
					col-class="stacked"
					v-on:change="filterChange"
					:params="{type:'btn-group',buttons:[
						{text: 'All',value: 'all'},
						{text: 'Processed',value: 1},
						{text: 'Un-processed',value: 0},
					]}"
					v-model="filterValues.processed">
				</field>

			</template>
			<template slot="heading"><slot></slot></template>
			<template slot="main">
				<freemium-locked-alert v-if="$store.company.is_freemium == 1"></freemium-locked-alert>

				<div class="d-flex flex-column flex-md-row flex-wrap justify-content-between align-items-stretch align-items-md-center expense-table-heading-row">
					<h2 v-if="heading" class="expense-table-heading mb-2 mb-md-0">
						{{heading}}
						<div v-if="headingSmall">
							<small>{{headingSmall}}</small>
						</div>
					</h2>
					<div v-if="!hideInfoBoxes && expenseReportValues" class="d-flex flex-wrap expense-table-info-boxes">
						<info-box label="Subtotal Sum" :value="'$ '+expenseReportValues.subtotal_sum.toCurrency()" class="expense-table-info-box" :stacked="true" :standout="true"></info-box>
						<info-box label="Grand Total" :value="'$ '+expenseReportValues.grand_total_sum.toCurrency()" class="expense-table-info-box" :stacked="true" :standout="true"></info-box>
						<info-box label="Average" :value="'$ '+expenseReportValues.average_expense_total.toCurrency()" class="expense-table-info-box" :stacked="true" :standout="true"></info-box>
						<info-box label="Average Tip" :value="+expenseReportValues.average_tip_pct.toFixed(1) + '%'" class="expense-table-info-box" :stacked="true" :standout="true"></info-box>
						<info-box label="Count" :value="expenseReportValues.record_count" class="expense-table-info-box" :stacked="true" :standout="true"></info-box>
					</div>
				</div>

				<table-list
					key="expenseList"
					:loading="loading"
					:records="mutatedExpenses"
					:fields="mutatedFields"
					record-name="Expense"
					:has-edit="editable"
					:other-buttons="mutatedOtherButtons"
					id-field="slug"
					:hide-record-count="true"
					:sortable="true"
					:total-paginated-records="numResults"
					v-on:viewReceipt="openReceiptMenu"
					v-on:otherButtonClick="otherButtonClick"
					v-on:viewPurchaseOrder="viewPurchaseOrder"
					v-on:edit="editRecord">

					<slot name="above-table"></slot>

					<div class="d-flex flex-row align-items-center flex-wrap">

						<div v-if="filteringTools" class="mr-auto d-flex">
							<button :disabled="panelToggled" class="btn btn-light mr-2" v-on:click="openFilterPanel">
								<i class="fa fa-filter"></i>
								Filter
							</button>

							<button :disabled="!mutatedExpenses || !mutatedExpenses.length" class="btn btn-light" v-on:click="exportExpenses">
								<i class="fa fa-download"></i>
								Export as CSV
							</button>
						</div>

					</div>

				</table-list>

				<div class="text-center" v-if="mutatedExpenses.length > 0 && numPages > pageNum">
					<button class="btn btn-light" type="button" v-on:click="loadMore">
						Load More
					</button>
				</div>

				<!--<pagination :pages="numPages" :current-page="pageNum" v-on:pageChange="pageChange"></pagination>-->

			</template>
		</collapsible-panel>
		<template v-else>

			<freemium-locked-alert v-if="$store.company.is_freemium == 1"></freemium-locked-alert>

			<h2 v-if="heading">
				{{heading}}
				<template v-if="headingSmall">
					<br>
					<small>{{headingSmall}}</small>
				</template>
			</h2>

			<table-list
				key="expenseList"
				:loading="loading"
				:records="mutatedExpenses"
				:fields="mutatedFields"
				record-name="Expense"
				:has-edit="editable"
				:other-buttons="mutatedOtherButtons"
				id-field="slug"
				:hide-record-count="true"
				:sortable="true"
				:total-paginated-records="numResults"
				v-on:viewReceipt="openReceiptMenu"
				v-on:otherButtonClick="otherButtonClick"
				v-on:viewPurchaseOrder="viewPurchaseOrder"
				v-on:edit="editRecord">

				<slot name="above-table"></slot>

				<div v-if="!hideInfoBoxes && expenseReportValues" class="d-flex flex-wrap expense-table-info-boxes">
					<info-box label="Subtotal Sum" :value="'$ '+expenseReportValues.subtotal_sum.toCurrency()" class="expense-table-info-box" :stacked="true" :standout="true"></info-box>
					<info-box label="Grand Total" :value="'$ '+expenseReportValues.grand_total_sum.toCurrency()" class="expense-table-info-box" :stacked="true" :standout="true"></info-box>
					<info-box label="Average" :value="'$ '+expenseReportValues.average_expense_total.toCurrency()" class="expense-table-info-box" :stacked="true" :standout="true"></info-box>
					<info-box label="Average Tip" :value="+expenseReportValues.average_tip_pct.toFixed(1) + '%'" class="expense-table-info-box" :stacked="true" :standout="true"></info-box>
					<info-box label="Count" :value="expenseReportValues.record_count" class="expense-table-info-box" :stacked="true" :standout="true"></info-box>
				</div>

			</table-list>

			<div class="text-center" v-if="mutatedExpenses.length > 0 && numPages > pageNum">
				<button class="btn btn-light" type="button" v-on:click="loadMore">
					Load More
				</button>
			</div>

			<!--
			<pagination
				:pages="numPages"
				:current-page="pageNum"
				v-on:pageChange="pageChange">
			</pagination>
			-->

			<template slot="heading"><slot></slot></template>
		</template>

		<expense-edit-modal
			:visible="editModal.visible"
			:record="editModal.record"
			:approvable="editModal.expenseIsReviewable"
			:deleteable="true"
			:user-options-prop="userOptions()"
			:show-review-history="true"
			:has-comments="true"
			v-on:unProcessed="editModal.record.processed = 0"
			v-on:unReviewed="editModal.record.reviewed_by = 0"
			v-on:expenseDeleted="expenseDeleted"
			v-on:save="save"
			v-on:closeModal="editModal.visible = false">
		</expense-edit-modal>

		<image-viewer
			v-if="receiptUrl"
			:force-pdf="receiptUrlIsPdf ? true : false"
			v-on:close="receiptUrl=false"
			:url="receiptUrl">
		</image-viewer>

	</div>

</template>

<script>
import TableList from "../TableList"
import Field from "../Field"
import FormGroup from "../FormGroup"
import ModalDialog from "../ModalDialog"
import InfoBox from "../InfoBox"
import CollapsiblePanel from "@/layout_fragments/CollapsiblePanel"
import JobPicker from "@/components/super_components/JobPicker"
import FreemiumLockedAlert from "@/components/FreemiumLockedAlert"

import ExpenseEditModal from "@/components/super_components/ExpenseEditModal"
import Pagination from "@/components/Pagination"
import ImageViewer from "@/components/ImageViewer"

export default {

	name: 'ExpenseTable',
	components: {
		TableList,
		Field,
		FormGroup,
		ModalDialog,
		CollapsiblePanel,
		InfoBox,
		ExpenseEditModal,
		Pagination,
		ImageViewer,
		JobPicker,
		FreemiumLockedAlert
	},
	props: [
		"heading", //main h2 heading
		"headingSmall",
		"showUser", //show user's name as a column and show filtering control
		"showJob", //show project name as a column,
		"hideInfoBoxes",
		"blockFetches", //if false, AJAX calls will be blocked until it becomes true
		"editable", //if false, edit controls will not appear,
		"filteringTools", //show filtering tools
		"filters",
		"showProcessedButtons",
		"customFields",
		"orders",
		"skipDateFromDefault"
	],
	data() {
		return {
			expenses: [],
			expenseReportValues: null,
			suppliers: [],
			filteredExpenseCodes: [],
			panelToggled: false,
			editModal: {
				visible: false,
				payload: {},
				record: {},
				expenseIsReviewable: false
			},
			deleteConfirmModal: {
				visible: false,
			},
			filterPanelRetracted: false,
			pageNum: 1,
			numPages: 1,
			numResults: null,
			group_id: null,
			filterValues: {
				job_id: null,
				service_id: null,
				user_id: null,
				dateFrom: null,
				dateTo: null,
				vendor: "",
				invoice_num: "",
				last_4: "",
				qbo_account_id: null,
				reviewed: "all",
				processed: 'all',
				supplier_id: null,
				group_id: null,
				code_id: null
			},
			fields: [
				//{label: "Expense Group",key: "expenseGroupName"},
				{label: "Expense Code",key: "expenseCodeName",showOnMobile:false},
				{label: "Purchase Date",key: "purchaseDate",sortBy:"date",showOnMobile:false},
				{label: "Subtotal",key: "cost",sortBy:"float",align: "right"},
				{label: "Tax",key: "tax",sortBy:"float",align: "right"},
				{label: "Tip",key: "tip",sortBy:"float",align: "right"},
				{label: "Total",key: "total",sortBy:"float",align: "right"},
				{label: "Description",key: "description"},
				{label: "Vendor",key: "vendor",showOnMobile:false},
				{label: "Invoice No.",key: 'invoice_num',showOnMobile: false},
				{label: "Card Number",key: "last_4",showOnMobile: false},
				{label: "Type",key:"payment_method",showOnMobile: false},
				{label: "Reviewed",key: "reviewedAt"},
				{label: "Approved",key: "approved",type:'boolean'},
				{label: "Processed",key: "processedIcon",type:'boolean'},
				//{label: "Payment Method",key: "payment_method"},
				//{label: "Reviewed By",key: "reviewedByName"},
				//{label: "Approved",key: "approvedIcon"},
				//{label: "Denied Reason",key: "shortDeniedReason"}
			],
			otherButtons: [
				{text: "View Receipt",icon:"fa-receipt",click: "viewReceipt",class: "btn-light"},
				{text: "View Purchase Order", icon: 'fa-eye', click: 'viewPurchaseOrder', class:'btn-light', condition: ["hasPurchaseOrder",true]}
			],
			expenseIncludes: [
				{model:"ExpenseGroup",fields:["group_name"]},
				{model:"ExpenseCode",fields:["code","description"]},
				{model:"User",fields: ["first_name","last_name"]},
				{model:"Job",fields:["job_name","job_num"]},
				{model:"Service",fields:["job_name","job_num"]},
				{model:"ReceiptImage",fields:["filename","thumb_filename","type","width","height"]},
				{model:"Contact",fields:["name"]},
				"PurchaseOrder"
			],
			receiptUrl: "",
			receiptUrlIsPdf: false,
			loading: true,
		}
	},
	watch: {
		blockFetches() {
			if (!this.blockFetches) {
				this.fetchExpenses()
			}
		},
		filters() {
			this.filterChange()
		}
	},
	computed: {
		expenseCodesFilteredOptions() {
			return this.optionify(this.$store.expenseCodes.map(code => {
				code.display = code.code + ": " + code.description

				return code
			}),"display")
		},
		editTotal() {
			let total = 0

			if (!isNaN(parseFloat(this.editModal.payload.cost)))
				total += parseFloat(this.editModal.payload.cost)

			if (!isNaN(parseFloat(this.editModal.payload.tax)))
				total += parseFloat(this.editModal.payload.tax)

			if (!isNaN(parseFloat(this.editModal.payload.tip)))
				total += parseFloat(this.editModal.payload.tip)

			return total.toFixed(2)
		},
		supplierOptions() {
			return this.optionify(this.suppliers,"name")
		},
		expensesTotals() {
			let vm = this

			let average = 0
			let subtotalSum = 0
			let grandTotal = 0
			let averageTip = 0
			let totalTip = 0
			let tipCount = 0
			let totalPreTip = 0;

			vm.expenses.forEach(expense => {

				let total = 0

				total = parseFloat(expense.cost)
				if (!isNaN(parseFloat(expense.tax)))
					total += parseFloat(expense.tax)

				if (!isNaN(parseFloat(expense.tip))) {

					if (parseFloat(expense.tip) > 0) {
						tipCount++
						totalPreTip += total

						totalTip += parseFloat(expense.tip)
					}

					total += parseFloat(expense.tip)

				}

				subtotalSum += parseFloat(expense.cost)
				grandTotal += total

			})

			if (vm.expenses.length > 0)
				average = grandTotal / vm.expenses.length

			if (tipCount > 0)
				averageTip = totalTip / totalPreTip * 100

			return {
				average: average,
				subtotalSum: subtotalSum,
				grandTotal: grandTotal,
				averageTip: averageTip
			}
		},
		mutatedOtherButtons() {
			let otherButtons = this.otherButtons

			if (this.showProcessedButtons)
				otherButtons.push({text: "Process",icon:"fa-check",click: "processExpense",class: "btn-success",condition:['processed',0]})

			return otherButtons
		},
		initialFromDate() {
			//calculate 30 days ago
			return this.moment().subtract(60,"days").format("YYYY-MM-DD")
		},
		mutatedFields() {
			if (this.customFields)
				return this.customFields

			let fields = this.fields

			if (this.showJob) {
				fields.unshift({
					label: "Project/Service",
					key: "projectName",
					type: "link"
				})
			}
			if (this.showUser) {
				fields.unshift({
					label: "Employee",
					key: "userFullName",
					type: "link"
				})
			}

			if (this.qboIsActive) {
				fields.push({
					label: "Pushed to QB",
					key: "pushedToQB",
					align: "center"
				})
			}

			return fields
		},
		mutatedExpenses() {
			let vm = this

			return vm.expenses.map(expense => {
				expense.userFullName = {
					text: expense.User ? expense.User.first_name + " " + expense.User.last_name : "",
					link: "/employee/"+expense.User.slug+"/profile"
				}

				expense.projectName = {
					text: "",
					link: ""
				}

				if (expense.Job) {
					expense.projectName = {
						text: expense.Job ? expense.Job.job_num +": "+ expense.Job.job_name : "",
						link: "/project/"+expense.Job.slug+"/dashboard"
					}
				}
				else if (expense.Service) {
					expense.projectName = {
						text: expense.Service ? expense.Service.job_num +": "+ expense.Service.job_name : "",
						link: "/service/"+expense.Service.slug+"/dashboard"
					}
				}

				expense.expenseGroupName = expense.ExpenseGroup ? expense.ExpenseGroup.group_name : ""
				expense.expenseCodeName = expense.ExpenseCode ? expense.ExpenseCode.code : ""

				expense.receiptImageLink = ""
				if (expense.ReceiptImage)
					expense.receiptImageLink = window.apiRoot + "resources/receipt-images/" + vm.$store.sessionToken + "/" + expense.ReceiptImage.filename


				if (expense.ReviewedBy) {
					expense.reviewedByName = expense.ReviewedBy.first_name+ " "+expense.ReviewedBy.last_name

					expense.approvedIcon = expense.approved == 1 ? "<i class='fa fa-check'></i>" : "<i class='fa fa-times'></i>"
				}
				else {
					expense.reviewedByName = ""
					expense.approvedIcon = ""
				}

				expense.total = parseFloat(expense.cost)
				if (!isNaN(parseFloat(expense.tax)))
					expense.total += parseFloat(expense.tax)
				if (!isNaN(parseFloat(expense.tip)))
					expense.total += parseFloat(expense.tip)

				expense.total = expense.total.toFixed(2)

				expense.processedIcon = false
				if (expense.processed == 1)
					expense.processedIcon = true

				expense.shortDeniedReason = expense.denied_reason.substring(0,12)+"..."

				expense.purchaseDate = vm.formatDate(expense.purchase_date)

				expense.reviewedAt = expense.reviewed_at == "0000-00-00 00:00:00" ? "<i class='fa fa-times'></i>" : vm.formatDateTimeToLocal(expense.reviewed_at)

				expense.pushedToQB = ""
				if (expense.reviewed_by > 0) {

					if (expense.qbo_id > 0)
						expense.pushedToQB = "<i class='text-success fa fa-check-circle' title='This expense has been pushed to QB'></i>"
					else
						expense.pushedToQB = "<i class='text-danger fa fa-times-circle' title='This expense should have been pushed to QB, but there was an error'></i>"
				}

				if ("Supplier" in expense && expense.Supplier)
					expense.vendor = expense.Supplier.name

				expense.hasPurchaseOrder = false
				if ("PurchaseOrder" in expense && expense.PurchaseOrder)
					expense.hasPurchaseOrder = true

				return expense
			})
		}
	},
	methods: {
		openFilterPanel() {
			let vm = this
			this.panelToggled = true

			if (this.$store.qboCreditCardAccounts.length == 0) {
				this.fetchQBOResource("Account","AccountType='Credit Card'",false).then(response => {
					if (response.success)
						vm.$store.qboCreditCardAccounts = response.data
				})
			}
		},
		setEditModalExpenseReviewable() {
			let vm = this
			this.editModal.expenseIsReviewable = false
			if (this.hasModulePermWrite("Expenses"))
				this.editModal.expenseIsReviewable = true

			else {
				//check role on job to see if they have review_expenses
				if (this.editModal.record) {
					let key, jobId, resource
					if ("job_id" in this.editModal.record && this.editModal.record.job_id > 0) {
						key = "job_id"
						resource = "JobUser"
					}
					else if ("service_id" in this.editModal.record && this.editModal.record.service_id > 0) {
						key = "service_id"
						resource = "ServiceUser"
					}
					
					jobId = this.editModal.record[key]

					let params = {
						filters: [
							["user_id", this.$store.userDetails.id],
							[key, jobId]
						],
						include: [
							{
								model: "JobPersonnelRole",
								filters: [
									["review_expenses",1]
								]
							}
						]
					}

					this.getJSON(resource + "/get",params).then(response => {
						if (response.success) {
							if (response.data.length > 0) {
								let hasReviewExpenses = response.data.find(jobUser => {
									console.log(jobUser)
									if ("JobPersonnelRole" in jobUser && jobUser.JobPersonnelRole) {
										console.log("has JobPersonnelRole", jobUser.JobPersonnelRole.review_expenses,jobUser.JobPersonnelRole.review_expenses == 1)
										return jobUser.JobPersonnelRole.review_expenses == 1
									}
								}) ? true : false

								vm.editModal.expenseIsReviewable = hasReviewExpenses
							}
						}
					})
				}
			}
		},
		exportExpenses() {
			const fields = this.mutatedFields
			const headerRow = fields.map(field => field.label)

			const rows = this.mutatedExpenses.map(row => {
				let renderedRow = []

				fields.forEach(field => {

					if (row[field.key] === null || row[field.key] === undefined)
						renderedRow.push("")

					else if (typeof(row[field.key]) == 'object') {
						if ('text' in row[field.key] && row[field.key].text)
							renderedRow.push(row[field.key].text)
						else
							renderedRow.push("")
					}

					else if (typeof(row[field.key]) == 'string' && row[field.key].includes("<i class=")) {
						let boolVal = row[field.key]
						if (row[field.key].includes("fa-times"))
							boolVal = false
						else if (row[field.key].includes("fa-check"))
							boolVal = true
						renderedRow.push(boolVal)

					} else {
						renderedRow.push(row[field.key])
					}
				})

				return renderedRow
			})

			this.exportToCSV("Expenses.csv", [headerRow, ...rows])
		},
		expenseDeleted() {
			this.editModal.visible = false

			this.fetchExpenses()
		},
		pageChange(page) {
			this.pageNum = page

			this.fetchExpenses()
		},
		loadMore() {
			this.pageChange(this.pageNum + 1)
		},
		otherButtonClick(record,action) {
			if (action == "processExpense") {
				let vm = this

				let payload = {
					id: record.id,
					processed: 1,
					skipQBOPush: true
				}

				this.saveRecord("Expense",payload,response => {
					vm.alertSuccess("Expense marked as processed")
					record.processed = 1
					vm.fetchExpenses()
				})
			}
		},
		viewPurchaseOrder(expense) {
			this.receiptUrlIsPdf = true
			this.receiptUrl = this.apiBase+"PurchaseOrder/pdf?slug="+expense.PurchaseOrder.slug+"&token="+this.$store.sessionToken+"&humanReadable=true&v=1"
		},
		filterChange() {
			this.pageNum = 1
			this.fetchExpenses(true)
		},
		renderFilters() {
			let filters = [], vm = this
			if (typeof this.filters != "undefined" && this.filters.length > 0)
				filters = this.cloneObj(this.filters)

			let basicFilters = ["job_id","service_id","user_id","last_4","supplier_id","code_id","qbo_account_id"]

			basicFilters.forEach(key => {
				if (vm.filterValues[key])
					filters.push([key,vm.filterValues[key]])
			})

			if (vm.filterValues.dateFrom)
				filters.push(["purchase_date >=",vm.filterValues.dateFrom+" 00:00:00"])

			if (vm.filterValues.dateTo)
				filters.push(["purchase_date <=",vm.filterValues.dateTo+" 23:59:59"])

			if (vm.filterValues.vendor != "")
				filters.push(["vendor",vm.filterValues.vendor,"and","like"])

			if (vm.filterValues.invoice_num != "")
				filters.push(["invoice_num",vm.filterValues.invoice_num.replace(/\s/g, ''),"and","like"])

			if (vm.filterValues.reviewed == 'reviewed')
				filters.push(["reviewed_by >",0])

			else if (vm.filterValues.reviewed == 'unreviewed')
				filters.push(["reviewed_by",0])

			if (vm.filterValues.processed != 'all')
				filters.push(["processed",vm.filterValues.processed])

			return filters
		},
		fetchExpenses(showLoading) {
			this.spinner(true)

			if (showLoading)
				this.loading = true

			let vm = this

			let expenseIncludes = this.expenseIncludes

			this.$nextTick(() => {

				let params = {
					filters: this.renderFilters(),
					include: expenseIncludes,
					page: vm.pageNum
				}

				if (vm.orders)
					params.orders = vm.orders

				vm.fetchReportFields()

				vm.getJSON("Expense/get",params,true).then(response => {

					if (response.success) {

						if (vm.pageNum == 1)
							vm.expenses = response.data
						else {
							vm.expenses = [
								...vm.expenses,
								...response.data
							]
						}

						vm.numPages = response.meta.num_pages
						vm.numResults = response.meta.num_results
					}

					vm.spinner(false)

					if (showLoading)
						vm.loading = false
				})
			})
		},
		fetchReportFields() {
			let vm = this
			let params = {
				filters: this.renderFilters()
			}

			this.getJSON("Expense/report",params).then(response => {
				if (response.success) {
					vm.expenseReportValues = response.data

					Object.keys(vm.expenseReportValues).forEach(key => {
						vm.expenseReportValues[key] = +vm.expenseReportValues[key]
					})
				}
			})
		},
		fetchOptions() {
			let vm = this

			let supplierParams = {
				filters: [
					["is_supplier",1],
				],
				fields: ["id","slug","name","is_supplier"]
			}

			let promises = [
				this.fetchUsers([],false,["first_name","last_name","email"]),
				this.fetchModel('ExpenseGroup'),
				this.fetchJobs([],false,['job_num',"job_name"]),
				this.getJSON("Contact/get",supplierParams)
			]

			this.spinner(true)

			Promise.all(promises).then(responses => {
				this.spinner(false)

				if (responses[3].success)
					vm.suppliers = responses[3].data
			})
		},
		deleteExpenseConfirm() {
			this.deleteConfirmModal.visible = true
		},
		deleteExpense() {
			let vm = this

			this.postData("Expense/delete",{id: this.editModal.record.id}).then(response => {
				vm.alertSuccess("Expense deleted")
				vm.editModal.visible = false
				vm.editModal.record = {}
				vm.deleteConfirmModal.visible = false
				vm.fetchExpenses()
			})
		},
		editRecord(record) {

			this.editModal.visible = true
			this.editModal.record = record

			this.setEditModalExpenseReviewable()
		},
		save(payload) {
			let vm = this

			this.postData("Expense/save",payload,true).then(response => {
				if (response.success) {
					vm.alertSaved("Expense Saved")
					vm.editModal.visible = false
					vm.fetchExpenses(true)
				}
			})

		},
		openReceiptMenu(expense) {
			this.receiptUrlIsPdf = false
			this.receiptUrl = expense.receiptImageLink
		},
		fetchDirectExpense(slug) {
			let vm = this

			let params = {
				include: this.expenseIncludes
			}

			this.getJSON("Expense/find/"+slug,params,true).then(response => {
				if (response.success) {
					vm.editModal.visible = true
					vm.editModal.record = response.data
				}
			})
		}
	},
	created() {
		if (!this.skipDateFromDefault)
			this.filterValues.dateFrom = this.initialFromDate

		if (!this.blockFetches)
			this.fetchExpenses(true)

		//check if a there is a direct link to a record
		if (this.$route.name == 'ExpensesWithSlug' && "slug" in this.$route.params && this.$route.params.slug)
			this.fetchDirectExpense(this.$route.params.slug)

		this.fetchOptions()
	}

}
</script>

<style scoped>
.expense-table-info-boxes {
	gap: 0.35rem;
}

@media (min-width: 768px) {
	.expense-table-heading-row .expense-table-info-boxes {
		justify-content: flex-end;
	}
}

.expense-table-info-box {
	flex: 1 1 7.25rem;
	min-width: 0;
	max-width: 100%;
}
</style>